import { render } from "./TheNavbar.pug?vue&type=template&id=279c2d4a&lang=pug"
import script from "./TheNavbar.js?vue&type=script&lang=js"
export * from "./TheNavbar.js?vue&type=script&lang=js"

import exportComponent from "/builds/projekte/pvp/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__